import { REGISTERED_MODULES } from "../modules/index.js";
import { composeClasses } from "../modules/compose.js";
/**
 * One class per navigation key. Total by construction: a key added to
 * MODULE_KEYS without a class here fails to compile.
 *
 * Keys prefixed `h-` are section headings inside a group, not screens;
 * they carry the class of the group that hosts them.
 */
const BASE_MODULE_CLASSES = {
    // ── Invoicing spine and its group ──
    main: "transversal-core",
    dashboard: "transversal-core",
    "ventes-caisse": "transversal-core",
    invoices: "transversal-core",
    verification: "transversal-core",
    "mcf-signatures-en-doute": "transversal-core",
    "sales-quotes": "transversal-core",
    "sales-delivery-notes": "transversal-core",
    "sales-recurring": "transversal-core",
    "sales-reminders": "transversal-core",
    pos: "transversal-optional",
    // ── Clients ──
    "clients-crm": "transversal-core",
    clients: "transversal-core",
    "crm-leads": "transversal-optional",
    "crm-opportunities": "transversal-optional",
    "crm-activities": "transversal-optional",
    // ── Catalogue ──
    catalogue: "transversal-core",
    articles: "transversal-core",
    depots: "transversal-optional",
    inventories: "transversal-optional",
    stock: "transversal-optional",
    // ── Purchasing ──
    achats: "transversal-optional",
    suppliers: "transversal-optional",
    "purchase-orders": "transversal-optional",
    "supplier-invoices": "transversal-optional",
    "import-costs": "transversal-optional",
    // ── Accounting: the group, its headings and its screens. Regime-gated
    // entries stay here — the regime, not the sector, is what closes them. ──
    accounting: "transversal-core",
    "accounting-dashboard": "transversal-core",
    "h-saisie": "transversal-core",
    "accounting-entries": "transversal-core",
    "accounting-auxiliaries": "transversal-core",
    "accounting-lettering": "transversal-core",
    "accounting-reconciliation": "transversal-core",
    "accounting-supporting-documents": "transversal-core",
    "h-etats": "transversal-core",
    "accounting-journal-report": "transversal-core",
    "accounting-general-ledger": "transversal-core",
    "accounting-trial-balance": "transversal-core",
    "accounting-analytic-balance": "transversal-core",
    "accounting-auxiliary-balance": "transversal-core",
    "accounting-aged-balance": "transversal-core",
    "accounting-statements": "transversal-core",
    "h-immos": "transversal-core",
    "accounting-assets": "transversal-core",
    "accounting-depreciations": "transversal-core",
    "h-pilotage": "transversal-core",
    "accounting-budgets": "transversal-core",
    "accounting-budget-vs-actual": "transversal-core",
    "accounting-cost-centers": "transversal-core",
    "h-referentiel": "transversal-core",
    "accounting-analytic-axes": "transversal-core",
    "accounting-chart": "transversal-core",
    "accounting-periods": "transversal-core",
    "accounting-closing": "transversal-core",
    "accounting-exchange-rates": "transversal-core",
    "accounting-settings": "transversal-core",
    // ── Simplified accounting (SMT regime) ──
    smt: "transversal-core",
    "accounting-smt": "transversal-core",
    "accounting-settings-smt": "transversal-core",
    // ── Donor funding and reporting (SYCEBNL regime) ──
    funding: "transversal-core",
    reporting: "transversal-core",
    "reporting-donor": "transversal-core",
    // ── Budget engine ──
    budget: "transversal-optional",
    "budget-execution": "transversal-optional",
    "budget-envelopes": "transversal-optional",
    "budget-commitments": "transversal-optional",
    "budget-visas": "transversal-optional",
    "budget-ordonnancement": "transversal-optional",
    // ── Tax ──
    fiscalite: "transversal-core",
    "declarations-list": "transversal-core",
    "declarations-calendar": "transversal-core",
    "accounting-vat": "transversal-core",
    "accounting-liasse-esintax": "transversal-core",
    // ── Payroll ──
    hr: "transversal-optional",
    "hr-employees": "transversal-optional",
    "hr-leaves": "transversal-optional",
    "hr-payroll": "transversal-optional",
    "hr-payroll-parameters": "transversal-optional",
    // ── Projects ──
    projects: "transversal-optional",
    "projects-list": "transversal-optional",
    // ── Reports and accounting-firm portal ──
    "reports-hub": "transversal-core",
    "reports-fiscal": "transversal-core",
    reports: "transversal-core",
    cabinet: "transversal-core",
    "cabinet-dossiers": "transversal-core",
    "cabinet-settings": "transversal-core",
    // ── Administration ──
    admin: "transversal-core",
    "h-acces": "transversal-core",
    users: "transversal-core",
    roles: "transversal-core",
    audit: "transversal-core",
    "h-structure": "transversal-core",
    establishments: "transversal-optional",
    settings: "transversal-core",
    "h-integrations": "transversal-core",
    "erp-connection": "transversal-core",
    webhooks: "transversal-core",
    "pispi-events": "transversal-core",
    imports: "transversal-core",
    onboarding: "transversal-core",
    "h-saas": "transversal-core",
    billing: "transversal-core",
    "node-health": "transversal-core",
};
/**
 * Core's own classification plus each contributed key's declared class. The
 * class comes from the contribution, never from the module: one module may
 * bring both sector-specific screens and transversal capability.
 *
 * `MODULE_CONTRIBUTED_KEYS` and the modules' own declarations are two lists
 * that must agree; `module-registry.test.ts` asserts they do, because a key
 * present in one and absent from the other lands here as `undefined`.
 */
export const MODULE_CLASSES = composeClasses(BASE_MODULE_CLASSES, REGISTERED_MODULES);
export function getModuleClass(key) {
    return MODULE_CLASSES[key];
}
//# sourceMappingURL=module-classes.js.map